import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import Statics from "./components/Statics";
import style from "./index.module.scss";
import { CourseContext } from "pages/CourseDetail/Store";
import { getMarkListItem } from "../../../../../service/exercise";

interface ButtonsProps {
    status: string;
    exerciseAllCount: string;
    noJudgeCount: string;
    judgeCount: string;
    noJoinInExerciseCount: string;
    onChange: (val: string) => void;
    exerciseId: string;
    data: getMarkListItem[];
}

export default function Buttons({
    status,
    exerciseAllCount,
    noJudgeCount,
    judgeCount,
    noJoinInExerciseCount,
    onChange,
    exerciseId,
    data
}: ButtonsProps) {
    const history = useHistory();
    const { basename } = useContext(CourseContext);

    return (
        <div className={style.root}>
            <Statics
                current={status}
                onChange={onChange}
                exerciseAllCount={exerciseAllCount}
                noJudgeCount={noJudgeCount}
                judgeCount={judgeCount}
                noJoinInExerciseCount={noJoinInExerciseCount}
            />

            <div className={style.buttons}>
                <button
                    className={style.btnView}
                    onClick={() =>
                        history.replace(
                            `${basename}/exercise/statics/${exerciseId}`
                        )
                    }>
                    查看练习分析
                </button>

                {/*<DownloadBtn*/}
                {/*    exerciseId={exerciseId}*/}
                {/*    name="课堂练习"*/}
                {/*    data={data}*/}
                {/*/>*/}
                {/* <button className={style.btnDown}>下载练习成绩</button> */}
            </div>
        </div>
    );
}
